import * as React from "react";
import { TitleFieldProps } from "@rjsf/utils";
import { LocalizedText } from "./LocalizedText";
import { mergeStyles } from "@fluentui/react";

/**
 * The title field
 *
 * @param props - the component props
 * @returns the markup
 */
export const TitleField: React.FC<TitleFieldProps> = (props) => {
  const { title, id } = props;
  const titleStyle = mergeStyles({
    fontSize: 18,
    fontWeight: 400,
    margin: 0,
  });
  return title ? (
    <legend id={id}>
      <h2 className={titleStyle}>
        <LocalizedText stringId={title} />
      </h2>
    </legend>
  ) : (
    <></>
  );
};
